// extracted by mini-css-extract-plugin
export var active = "styles-module__active____C5GF";
export var inactive = "styles-module__inactive___U90pa";